// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WJ14aFod-gPW_us5b6mMl"};